<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <!--begin::Form-->
  <form class="form" [formGroup]="patientInsuranceForm" autocomplete="off">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <div class="field-row">
        <mat-form-field appearance="fill" style="width: 100%">
          <mat-label>Plan Name</mat-label>
          <mat-select
            formControlName="insurance"
            (selectionChange)="handleInsuranceChange($event)"
            required
          >
            <mat-option *ngFor="let insurance of allInsurances" [value]="insurance.id">
              {{ insurance.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isControlHasError('insurance', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="field-row">
        <div>
          <mat-form-field class="example-full-width">
            <mat-label>BIN</mat-label>
            <input matInput disabled [value]="selectedInsurance?.bin" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="example-full-width">
            <mat-label>PCN</mat-label>
            <input matInput disabled [value]="selectedInsurance?.pcn" />
          </mat-form-field>
        </div>
      </div>

      <div class="field-row">
        <div>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Insurance number</mat-label>
            <input matInput formControlName="insuranceId" required />
            <mat-error *ngIf="isControlHasError('insuranceId', 'required')">
              <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Group Number</mat-label>
            <input matInput formControlName="groupNumber" />
          </mat-form-field>
        </div>
      </div>

      <div class="field-row">
        <div>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Issue Date</mat-label>
            <input matInput formControlName="issueDate" [matDatepicker]="issueDate" required />
            <mat-datepicker-toggle matSuffix [for]="issueDate"></mat-datepicker-toggle>
            <mat-datepicker #issueDate></mat-datepicker>
            <mat-error *ngIf="isControlHasError('issueDate', 'required')">
              <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Expiry Date</mat-label>
            <input matInput formControlName="expiryDate" [matDatepicker]="expiryDate" />
            <mat-datepicker-toggle matSuffix [for]="expiryDate"></mat-datepicker-toggle>
            <mat-datepicker #expiryDate color="primary"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="field-row">
        <div>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Person Code</mat-label>
            <input matInput formControlName="personCode" required />
            <mat-error *ngIf="isControlHasError('personCode', 'required')">
              <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Priority</mat-label>
            <mat-select
              formControlName="priority"
              (selectionChange)="handleIsActiveCheckbox()"
              required
            >
              <mat-option *ngFor="let priority of availablePriorities" [value]="priority.value">
                {{ priority.key }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('priority', 'required')">
              <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="field-row">
        <div class="mat-form-field-fluid">
          <mat-label class="row ml-1" translate="DOCTOR.INPUT.STATUS">Status</mat-label>
          <mat-slide-toggle class="mr-2" formControlName="isActive"></mat-slide-toggle>
          <mat-hint align="start">
            <strong>{{ getStatusString() }}</strong>
          </mat-hint>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            cdkFocusInitial
            (click)="cancel()"
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            *ngIf="!isReadOnly"
            type="submit"
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
  <!--end::Form-->
</div>
